import _ from 'underscore';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { findSiteMap, siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { AdStudioSummaryBar } from '@bingads-webui-campaign-react/summary-bar';

const isLeafNode = item => item && item.children.length === 0 && item.selected === true;

const Loader = (props) => {
  const {
    siteMap,
    updateAvailability,
    isVisible,
    i18n,
    history,
    location,
    permissions,
  } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });
  const selectedChild = selectedParent && findSiteMap([selectedParent], isLeafNode);

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });

  return isVisible ? (
    <AdStudioSummaryBar
      selectedParent={selectedParent}
      selectedChild={selectedChild}
      i18n={i18n}
      history={history}
      siteMap={siteMap}
      location={location}
      permissions={permissions}
    />
  ) : null;
};

Loader.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool,
  history: PropTypes.shape({
    replace: PropTypes.func,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  permissions: PropTypes.shape({}).isRequired,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
  isVisible: false,
};

export const AdStudioSummaryBarLoader = React.memo(Loader);
